import Vue          from 'vue'
import { router }   from '../../router'

import { createActionHelpers } from 'vuex-loading'
const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
});

export default {
    state: {
        data: {}
    },

    getters: {

    },

    actions: {
        clearSingleData(context) {
            context.commit('clearSingleData')
        },
        setSingleData(context, params) {
            context.commit('setSingleData', { data: params.data })
        },
        updateSingleData(context, params) {
            context.commit('updateSingleData', { key: params.key, value: params.value })
        },
        addSingleData(context, params) {
            context.commit('addSingleData', { key: params.key, value: params.value })
        },
        removeSingleData(context, params) {
            context.commit('removeSingleData', { key: params.key })
        }
    },

    mutations: {
        clearSingleData(state) {
            state.data = {}
        },

        setSingleData(state, event) {
            state.data = event.data
        },

        updateSingleData(state, event) {
            let path    = state.data
            let split   = event.key.split('.')

            split.forEach((item, index) => {
                if((index + 1) < split.length) {
                    let start = item.indexOf('[')
                    let end = item.indexOf(']')

                    if(start > -1 && end > -1) {
                        let i = item.substring((start + 1), end)
                        path = path[item.substring(0, start)]
                        path = path[i]

                    } else {
                        path = path[item]
                    }

                } else {
                    let start = item.indexOf('[')
                    let end = item.indexOf(']')

                    if(start > -1 && end > -1) {
                        let i   = item.substring((start + 1), end)
                        path    = path[item.substring(0, start)]
                        path[i] = event.value

                    } else {
                        path[item] = event.value
                    }

                }
            })
        },

        addSingleData(state, event) {
            let path    = state.data
            let split   = event.key.split('.')

            split.forEach((item, index) => {
                if((index + 1) < split.length) {
                    path = path[item]

                } else if(item == '[]', Array.isArray(path)) {
                    path.push(event.value)

                } else {
                    path[item] = event.value
                }
            })
        },

        removeSingleData(state, event) {
            let path    = state.data
            let split   = event.key.split('.')

            split.forEach((item, index) => {
                if((index + 1) < split.length) {
                    let start = item.indexOf('[')
                    let end = item.indexOf(']')

                    if(start > -1 && end > -1) {
                        let i = item.substring((start + 1), end)
                        path = path[item.substring(0, start)]
                        path = path[i]

                    } else {
                        path = path[item]
                    }

                } else {
                    let start = item.indexOf('[')
                    let end = item.indexOf(']')

                    if(start > -1 && end > -1) {
                        let i = item.substring((start + 1), end)
                        path = path[item.substring(0, start)]

                        if(Array.isArray(path)) {
                            path.splice(i, 1)

                        } else {
                            // Ne devrait jamais servir...
                            delete path[i]
                        }


                    } else {
                        delete path[item]
                    }
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/single.js